import _LoadingOutlined from "@zenlayer/zen-design-icons/assets/LoadingOutlined.svg";
import classNames from 'classnames';
import React, { useMemo } from 'react';
import { error as errorConsoleLog } from '../_util/devConsoleLog';
import insertRipple from '../_util/insertRipple';
import { pickDomAttrs } from '../_util/utils';
import Explain from '../explain';
import Icon from '../icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const checkChildren = Element => {
  if (! /*#__PURE__*/React.isValidElement(Element)
  // || (Element.type as any).name !== Select.name
  ) {
    errorConsoleLog(true, 'TextField', 'The "TextField" children error.');
    return false;
  }
  return true;
};
const TextField = props => {
  const {
    label,
    type,
    shrink,
    isFocus,
    size,
    disabled,
    loading,
    error,
    readonly,
    mText,
    prefix,
    suffix,
    style,
    width,
    wrapClassName,
    className,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    children,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-textField");
  const attrs = pickDomAttrs(restProps);

  // errorConsoleLog(
  //   type === 'filled' && size === 's',
  //   'Select',
  //   'When type is "filled", "size" does not have the "s" attribute.'
  // );

  const child = useMemo(() => {
    return checkChildren(children) ? /*#__PURE__*/React.cloneElement(children, {
      className: classNames(children.props.className, "".concat(baseClassName, "-content"))
    }) : null;
  }, [children]);
  const prefixIcon = useMemo(() => {
    return prefix ? /*#__PURE__*/React.cloneElement(prefix, {
      className: classNames(prefix.props.className, "".concat(baseClassName, "-prefixIcon"), {
        mText
      })
    }) : null;
  }, [prefix, mText]);
  const suffixIcon = useMemo(() => {
    if (loading) {
      return /*#__PURE__*/_jsx("div", {
        className: classNames("".concat(baseClassName, "-suffixIcon"), {
          mText
        }),
        children: /*#__PURE__*/_jsx(Icon, {
          type: "LoadingOutlined",
          style: {
            display: 'block'
          }
        })
      });
    }
    return suffix ? /*#__PURE__*/React.cloneElement(suffix, {
      className: classNames(suffix.props.className, "".concat(baseClassName, "-suffixIcon"), {
        mText
      })
    }) : null;
  }, [suffix, loading, mText]);
  return /*#__PURE__*/_jsx(Explain, {
    ...attrs.data,
    helperText: error === true ? undefined : error,
    wrapClassName: wrapClassName,
    children: /*#__PURE__*/_jsxs("div", {
      className: classNames(baseClassName, className, {
        ["".concat(baseClassName, "-").concat(type)]: !!type,
        ["".concat(baseClassName, "-shrink")]: shrink,
        ["".concat(baseClassName, "-").concat(size)]: !!size,
        ["".concat(baseClassName, "-focus")]: isFocus,
        ["".concat(baseClassName, "-disabled")]: !!disabled,
        ["".concat(baseClassName, "-error")]: !!error,
        ["".concat(baseClassName, "-loading")]: !!loading,
        ["".concat(baseClassName, "-readonly")]: !!readonly,
        ["".concat(baseClassName, "-with-prefixIcon")]: !!prefixIcon,
        ["".concat(baseClassName, "-with-suffixIcon")]: !!suffixIcon
      }),
      ref: ref => {
        insertRipple({
          className: "".concat(prefixClass, "-ripple"),
          ref
        });
      },
      style: {
        width,
        height: mText ? 'auto' : undefined,
        minHeight: mText,
        ...style
      },
      children: [prefixIcon, suffixIcon, /*#__PURE__*/_jsxs("div", {
        className: classNames("".concat(baseClassName, "-border")),
        children: [/*#__PURE__*/_jsx("div", {
          className: classNames("".concat(baseClassName, "-border-leading"))
        }), /*#__PURE__*/_jsx("div", {
          className: classNames("".concat(baseClassName, "-border-notch")),
          children: /*#__PURE__*/_jsx("div", {
            className: classNames("".concat(baseClassName, "-label"), {
              mText
            }),
            children: label
          })
        }), /*#__PURE__*/_jsx("div", {
          className: classNames("".concat(baseClassName, "-border-trailing"))
        })]
      }), child]
    })
  });
};
export default TextField;